/** Fixed top bar shown only while a service page is in edit mode — the one exception to "no extra chrome". */
export default function EditorTopBar({ title, preview, onTogglePreview, onSave, saving, statusLabel, onBack }) {
  return (
    <div className="svcpg-topbar">
      <div className="svcpg-topbar__left">
        <button type="button" className="svcpg-toolbar__btn" onClick={onBack}>
          ← Back
        </button>
        <span className="svcpg-topbar__title">{title}</span>
      </div>
      <div className="svcpg-topbar__right">
        <span className="svcpg-topbar__status">{statusLabel}</span>
        <button type="button" className="svcpg-toolbar__btn" onClick={onTogglePreview}>
          {preview ? 'Exit preview' : 'Preview'}
        </button>
        <button
          type="button"
          className="svcpg-toolbar__btn svcpg-toolbar__btn--active"
          onClick={onSave}
          disabled={saving}
        >
          {saving ? 'Saving…' : 'Save'}
        </button>
      </div>
    </div>
  );
}
